var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PmwParagraph',{staticClass:"lang-text"},[_c('img',{staticClass:"lang-text--flag",attrs:{"src":_vm.flagImgPath,"alt":_vm.text}}),_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }